const getPictureColumnImages = (dataItem, pictures) => {
  if (!dataItem.pictures) return []
  return dataItem.pictures.filter((picture) => { return pictures.includes(picture.uuid) })
}

export default getPictureColumnImages
